import styled from 'styled-components/macro';

export const SubTitle = styled.h3`
  font-size: 1.25rem;
  margin: 0;
  color: ${p => p.theme.text};
`;
